import { Instance, types } from 'mobx-state-tree';
import { gameStore } from './game';
import { createComparerOfSorting, SortType } from 'easit--utils';

export const gameGroupStore = types
    .model({
        Games: types.array(gameStore),
        ID: types.number,
        Name: types.maybeNull(types.string)
    })
    .views(self => ({
        get sortedGames() {
            return self.Games.sort(createComparerOfSorting(g => g.Sequence, SortType.Asc));
        }
    }));

export type IGameGroupStore = Instance<typeof gameGroupStore>;